import { Environment, eul10n } from './shared.models';

export const environment: Environment = {
  production: true,
  devTools: false,
  hmr: false,
  name: 'production',
  authEnv: 'production',
  appUrl: 'https://maps.app.vdo-fleet.com',
  useSettingsApi: false,
  datadog: {
    applicationId: '376213ad-4a16-4ec0-9af4-43bfaf54fbc1',
    clientToken: 'pub07dd18e3a77864f9153835ece3c3c745',
    tagEnvironment: 'tm-production'
  },
  devCycle: {
    clientId: 'dvc_client_6ba8b96a_4788_4fb8_ab98_4fe5974a8bb7_c693982'
  },
  here: {
    apiKeyV3: 'EwFELkwQlsuaqtesDn_8Y3cNocImNxd-dVGo_qrwx30'
  },
  auth: {
    clientID: 'zWRuHl1Xmq2PckEs2JEaOnhDgK97OlGs',
    // domain: 'auth.production.continental-mobility-services.com',
    domain: 'login.auth.vdo-fleet.com',
    // audience: 'https://api.production.continental-mobility-services.com',
    audience: 'https://api.fleet.vdo.com',
    applicationId: '502a135c-c9aa-4f83-a315-10d8ec648162',
    useRefreshTokens: true,
    maxAge: 36000
  },
  locationApi: {
    url: 'https://www.my-fis.com/311/dmm50/edge-server/historical-asset-service/api/v1',
    hasAssociatedDevice: true
  },
  pathApiBase: {
    url: 'https://www.my-fis.com/311/dmm50/edge-server/historical-asset-service/api/v1'
  },
  geocoderApiBase: {
    url: 'https://www.my-fis.com/311/dmm50/edge-server/geocoder-service/api/v1'
  },
  pathApiRequestPageSize: 2000,
  dataUpdateMessages: {
    // units are minutes
    updateInterval: 1,
    idling: 60 * 12,
    notIdling: 15
  },
  nearbyAssets: {
    searchRadiusMeters: 50 * 1609, // 50 miles in meters
    assetsToReturn: 10,
    searchRadiusInKm: 80, // 80 km
    searchRadiusInMiles: 50 // 50 miles
  },
  liveUpdate: {
    pageSize: 300,
    concurrency: 7,
    pollingInterval: 10_000,
    consecutiveFailureLimit: 3,
    restartPollingDelay: 600_000
  },
  // zTrakBatteryAlertPct: 0.1,
  apiRequestPageSize: 500,
  datadogSite: 'datadoghq.eu',
  minimumTripMS: 60000,
  featureFlags: {
    assetIOs: false
  },
  region: 'EU',
  vdofleet: {
    baseApiUrl: 'https://www.my-fis.com/311/dmm50/edge-server',
    baseApiAudience: 'https://api.fleet.vdo.com'
  },
  // gtcxUrl: { can add gtcx urls in the future if they go to EU },
  euUrl: {
    vdoDashboardUrl: 'https://www.my-fis.com/311/dmm50/app/',
    vdoReportsUrl: 'https://www.my-fis.com/311/dmm50/app/reports/',
    geofencingUrl: 'https://www.my-fis.com/311/dmm50/app/geofencing/'
  },
  i18n: {
    supportedLanguages: [
      'en-US',
      'de-DE',
      'en-GB',
      'es-ES',
      'fr-FR',
      'it-IT',
      'bg-BG',
      'cs-CZ',
      'el-GR',
      'lt-LT',
      'pl-PL',
      'pt-PT',
      'ro-RO',
      'hr-HR',
      'sk-SK',
      'sl-SI',
      'mk-MK',
      'et-EE',
      'nb-NO',
      'nl-NL'
    ],
    defaultLanguage: 'en-GB'
  },
  l10n: eul10n,
  hamburgerMenuEnabled: false
  // legacyAccountsEnabled: false
};
